var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23423 5.83407C4.38425 5.6841 4.5877 5.59985 4.79983 5.59985C5.01196 5.59985 5.21541 5.6841 5.36543 5.83407L7.99983 8.46847L10.6342 5.83407C10.708 5.75767 10.7963 5.69672 10.8939 5.65479C10.9915 5.61287 11.0965 5.5908 11.2027 5.58987C11.3089 5.58895 11.4143 5.60919 11.5126 5.64942C11.6109 5.68964 11.7002 5.74904 11.7753 5.82416C11.8505 5.89927 11.9099 5.98859 11.9501 6.08691C11.9903 6.18523 12.0106 6.29057 12.0096 6.3968C12.0087 6.50302 11.9866 6.60799 11.9447 6.7056C11.9028 6.8032 11.8418 6.89148 11.7654 6.96527L8.56543 10.1653C8.41541 10.3153 8.21196 10.3995 7.99983 10.3995C7.7877 10.3995 7.58425 10.3153 7.43423 10.1653L4.23423 6.96527C4.08425 6.81525 4 6.61181 4 6.39967C4 6.18754 4.08425 5.9841 4.23423 5.83407Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlue);
export default __webpack_public_path__ + "static/media/chevron-down-blue.04f46dfcdcc4bc1292b06fee907e6b8f.svg";
export { ForwardRef as ReactComponent };